<script>
import { formatDatePretty } from '@/utils';

export default {
  props: {
    changes: {
      type: Array,
      required: true,
    },
  },
  computed: {
    formattedChanges () {
      return this.changes.map(change => {
        const [value] = change.path;
        const side = change.lhs ? 'lhs' : 'rhs';

        return { [side]: value };
      });
    },
  },
  render () {
    return (
      <div class="journal-diff">
        <div class="journal-diff__field">
          Выходные дни
        </div>
        {this.formattedChanges.map((change, i) => {
          const { lhs, rhs } = change;

          return (
            <div key={i}>
              {lhs && (
                <span class="journal-diff__del">
                  {formatDatePretty(lhs)}
                </span>
              )}
              {rhs && (
                <span class="journal-diff__ins">
                  {formatDatePretty(rhs)}
                </span>
              )}
            </div>
          );
        })}
      </div>
    );
  },
};
</script>
